export default "__VITE_ASSET__C2j7luGY__"